import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PasswordValidationService {
  atLeastOneNumber(control: AbstractControl): ValidationErrors | null {
    const oneNumber = /.*[0-9].*/g;

    return oneNumber.test(control.value) ? null : { NotAtLeastOneNumber: true };
  }

  atLeastOneLowerCase(control: AbstractControl): ValidationErrors | null {
    const lowerCase = /^(?=.*[a-z]).*$/g;

    return lowerCase.test(control.value) ? null : { NotAtLeastOneLowerCase: true };
  }

  atLeastOneSpecialCharacter(control: AbstractControl): ValidationErrors | null {
    const specialCharacter = /^(?=.*[\W_]).*/g;

    return specialCharacter.test(control.value) ? null : { NotAtLeastOneSpecialCharacter: true };
  }

  atLeastOneUpperCase(control: AbstractControl): ValidationErrors | null {
    const upperCase = /^(?=.*[A-Z]).*$/g;

    return upperCase.test(control.value) ? null : { NotAtLeastOneUpperCase: true };
  }

  minLength(control: AbstractControl): ValidationErrors | null {
    const minLength = /^.{12,}$/g;

    return minLength.test(control.value) ? null : { NotAtLeastMinLength: true };
  }

  noWhiteSpace(control: AbstractControl): ValidationErrors | null {
    const whiteSpace = /\s/g;

    return whiteSpace.test(control.value) ? { hasWhiteSpace: true } : null;
  }

  checkPasswordMatch(fg: UntypedFormGroup): ValidationErrors | null {
    const newPw = fg.get('newPassword');
    const confirmPw = fg.get('confirmPassword');

    if (!newPw || !confirmPw) {
      return null;
    }

    if (newPw.value === confirmPw.value) {
      confirmPw.setErrors(null);

      return null;
    }
    confirmPw.setErrors({ passwordMissmatch: true });

    return { passwordMissmatch: true };
  }
}
